import { createApiClient } from "#/shared/api/client";

// The "chatterbox" suggested-filter endpoint: a natural-language fallback used
// only by the landing omnisearch when a typed query has no local match. It maps
// free text to a set of filters (e.g. "knee pain near me" → body_system + …).
const SUGGESTED_FILTER_PATH = "/physicians/doctor_finder_autocomplete_suggested_filter.json";

export const createChatterboxApi = ({ api = "provider_search" } = {}) => {
  // The endpoint returns a plain JSON document, not the `{ meta, data }`
  // envelope ApiClient models — `parse: false` hands it back raw.
  const instance = createApiClient({ baseURL: SUGGESTED_FILTER_PATH, api, parse: false });

  return {
    suggest: (query, { signal } = {}) => instance.request("get", "", { params: { query }, signal }),
  };
};
